import { Outlet, useNavigate, Link, NavLink, useNavigation, useLocation, useMatch, useMatches } from "react-router-dom";
import "../Components/Styles/adminpanel.css";
import RagnaSidebar from "../Components/AdminPanelComponents/RagnaSidebar";
import { Col, Row } from "reactstrap";
import Breadcrumb from "../routes/crumbies";
import { routeTitles } from "./routeHeaders";
import RagnaModal from "../Components/ReactComponents/RagnaModal";
import { useEffect, useState } from 'react';
import AuthBox from "../Components/MainComponents/AuthBox";
import RagnaLoader from "../Components/ReactComponents/RagnaLoader";
import Cookies from 'universal-cookie';
import { _basename, ajax_api } from "../Globals";
import axios from 'axios';
import { Helmet } from 'react-helmet';

const Root = props => {
    const cookies = new Cookies();
    let navigation = useNavigation();
    const navigate = useNavigate();
    let loc = useLocation();
    let match = useMatches(loc)[0];
    const [modalOpen, setModalOpen] = useState(false);
    const [authModalOpen, setAuthModalOpen] = useState(false);
    const [creds, setCreds] = useState(); // cookies.get('creds') ? JSON.parse(decodeURI(cookies.get('creds'))) : null

    const DEBUG_MODE = false;

    let navTitles = match.params.Id != null ?
        routeTitles(loc.pathname.replace(match.params.Id, ":Id")) ??
        { title: "nyi", subtitle: "not yet implemented", btns: [] }
        :
        routeTitles(loc.pathname) ?? { title: "nyi", subtitle: "not yet implemented", btns: [] };

    const [loggingOut, setLoggingOut] = useState(false);
    const logout = _ => {
        setLoggingOut(true);
        axios.get(ajax_api + "auth/logout", { withCredentials: true }).then(_ => {
            setLoggingOut(false);
            setCreds();
            cookies.remove('creds');
            navigate("/dashboard");
        }).catch(e => {
            setLoggingOut(false);
            alert(e)
        });
        //api request to delete session vars / cookies
    }

    const polling = timeout => {
        setTimeout(_ => {
            axios.get(ajax_api + "auth/get-creds", { withCredentials: true }).then(r => {
                if (r.data.FullName != "") setCreds(r.data);
                else {
                    setCreds();
                    //alert(loc.pathname);
                    if (loc.pathname !== "/legislations" && loc.pathname !== "/dashboard")
                        navigate("/dashboard");

                    if (cookies.get('creds') != undefined) {
                        //alert("Session has timed out. Please login again.")
                        cookies.remove('creds');
                    }
                }
                polling(60 * 1000 * 2);
            }).catch(_ => setCreds());
        }, timeout)
    }

    useEffect(_ => {
        polling(20);
    }, []);


    const [hideNav, setHideNav] = useState(true);

    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        /* Inside of a "useEffect" hook add an event listener that updates
           the "width" state variable when the window size changes */
        window.addEventListener("resize", () => setWidth(window.innerWidth));

        /* passing an empty array as the dependencies of the effect will cause this
           effect to only run when the component mounts, and not each time it updates.
           We only want the listener to be added once */
    }, []);

    useEffect(() => {
        setHideNav(true);
    }, [loc]);

    return (
        <>
            <Helmet>
                <link rel="icon" type="image/png" href={_basename + "favicon.png"} sizes="16x16" />
            </Helmet>
            <div style={{ width: "100vw" }}>
                <div className="d-lg-none justify-content-start d-flex py-2 px-2"
                    style={{ height: 60, width: "100vw", background: "white" }}>
                    <span style={{ border: "1px solid #ccc", cursor: "pointer", borderRadius: 5 }} className="p-2 px-3" onClick={_ => setHideNav(h => !h)}>
                        <i class="fa fa-bars"></i>
                    </span>
                </div>
                <div className="d-flex" style={{
                    overflow: "hidden",
                    height: width > 992 ? "100%" : "calc(100vh - 60px)"
                }}>
                    <div id="sidebar" style={{
                        width: width > 992 ? "20vw" : 250,
                        zIndex: 9999, height: width > 992 ? "100%" : "calc(100vh - 60px)"
                    }} className={
                        "sidebar-nav d-flex "
                        + (width <= 992 ? "position-fixed" : "") +
                        (hideNav && width <= 992 ? " d-none" : "")
                    }>
                        <h2 className="text-center border-bottom m-0 pb-2 pt-2">
                            <img style={{ width: "100%" }} alt="logo" src={_basename + "favicon.png"} /> CGPP LTS
                        </h2>
                        <nav style={{ overflow: "auto" }}>
                            <RagnaSidebar
                                access={DEBUG_MODE ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 96]
                                    : (creds?.Access.split(",") ?? [])}
                                routes={
                                    [
                                        {
                                            Name: "Main Menu",
                                            IsHeader: true
                                        },
                                        {
                                            Name: "Dashboard",
                                            URL: "dashboard",
                                            IconClass: "fas fa-dashboard"
                                        },
                                        //{
                                        //    Name: "Documents",
                                        //    URL: "documents",
                                        //    IconClass: "fa-regular fa-file-pdf"
                                        //},
                                        //{
                                        //    Name: "Agenda",
                                        //    URL: "agenda",
                                        //    IconClass: "fa-solid fa-clipboard-list-check"
                                        //},
                                        {
                                            Name: "Legislations",
                                            URL: "legislations",
                                            IconClass: "fa fa-gavel"
                                        },
                                        //{
                                        //    Name: "Communications",
                                        //    URL: "communications",
                                        //    IconClass: "fa-regular fa-envelope-open-text"
                                        //},
                                        {
                                            Name: "Reports",
                                            URL: "reports",
                                            IconClass: "fas fa-file-chart-pie",
                                            Access: [2]
                                        },
                                        {
                                            Name: "Data Management",
                                            IsHeader: true,
                                            Access: [
                                                16, 17, 18, 19, 24, 25, 26, 27, 32, 33, 34, 35, 55, 56, 57, 58,
                                                51, 52, 53, 54, 28, 29, 30, 31,

                                            ]
                                        },
                                        {
                                            Name: "SP Items",
                                            URL: "sp-items",
                                            IconClass: "fas fa-books",
                                            Access: [55, 56, 57, 58]
                                        },
                                        {
                                            Name: "SP Item Properties",
                                            IconClass: "fa fa-list",
                                            URL: "item-properties",
                                            Access: [16, 17, 18, 19, 24, 25, 26, 27, 32, 33, 34, 35, 55, 56, 57, 58],
                                            Children: [
                                                {
                                                    URL: "types",
                                                    Name: "Item Types",
                                                    Access: [24, 25, 26, 27]
                                                },
                                                {
                                                    URL: "sessions",
                                                    Name: "Sessions",
                                                    Access: [92, 93, 94, 95]
                                                },
                                                {
                                                    URL: "committees",
                                                    Name: "Committees",
                                                    Access: [32, 33, 34, 35]
                                                },
                                                {
                                                    URL: "categories",
                                                    Name: "Categories",
                                                    Access: [16, 17, 18, 19]
                                                },
                                                //{
                                                //    URL: "status",
                                                //    Name: "Tracking Statuses",
                                                //    Access: [83]
                                                //}
                                            ]
                                        },
                                        {
                                            Name: "Officials",
                                            IconClass: "fa-solid fa-user-tie",
                                            URL: "officials",
                                            Access: [51, 52, 53, 54, 28, 29, 30, 31],
                                            Children: [
                                                {
                                                    URL: "list",
                                                    Name: "List",
                                                    Access: [51, 52, 53, 54]
                                                },
                                                {
                                                    URL: "types",
                                                    Name: "Official Types",
                                                    Access: [28, 29, 30, 31]
                                                },
                                                {
                                                    URL: "council-statuses",
                                                    Name: "Council Member Status",
                                                    Access: [51, 52, 53, 54]
                                                },
                                                {
                                                    URL: "committee-types",
                                                    Name: "Committee Types",
                                                    Access: [49]
                                                }
                                            ]
                                        },
                                        {
                                            Name: "Councils and Members",
                                            IconClass: "fa fa-users",
                                            URL: "councils",
                                            Access: [36, 37, 38, 39, 48, 49, 50],
                                            Children: [
                                                {
                                                    URL: "list",
                                                    Name: "Council List",
                                                    Access: [36, 37, 38, 39]
                                                },
                                                {
                                                    URL: "officials",
                                                    Name: "Council Members",
                                                    Access: [40, 41, 42]
                                                },
                                                {
                                                    URL: "committees",
                                                    Name: "Committees + Members",
                                                    Access: [48, 49, 50]
                                                }
                                            ]
                                        },
                                        {
                                            Name: "Admin Management",
                                            IconClass: "fa fa-toolbox",
                                            URL: "admin-panel",
                                            Access: [91, 92, 93, 94, 95, 83],
                                            Children: [
                                                {
                                                    URL: "logs",
                                                    Name: "Activity Logs",
                                                    Access: [91]
                                                },
                                                {
                                                    URL: "ftp-locations",
                                                    Name: "FTP Locations",
                                                    Access: [92, 93, 94, 95]
                                                },
                                                {
                                                    URL: "db-sync",
                                                    Name: "Database Sync",
                                                    IconClass: "fa fa-sync",
                                                    Access: [83]
                                                },
                                                {
                                                    URL: "files-relink",
                                                    Name: "Files Relink",
                                                    IconClass: "fa fa-chain",
                                                    Access: [83]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            />
                        </nav>
                        {
                            //style={width <= 992 ? { height: 0 } : {}}
                            //+(width > 992 ? "opacity-100":"opacity-0")
                        }
                        <div className="border-top pb-4">
                            {

                                creds ? <>
                                    {
                                        creds.ProfilePic == null || creds.ProfilePic == "" ?
                                            <i className="fa fa-user-circle text-success fa-3x" /> :
                                            <img style={{ width: 80, height: 80, borderRadius: "100%" }} src={creds.ProfilePic} alt="profile pic" />
                                    }
                                </>

                                    : ""}

                            <div>
                                <div>
                                    Welcome, <b>{creds?.FullName ?? "GUEST"}</b>!
                                </div>
                                <div className="badge rounded-pill bg-primary">
                                    {creds?.RoleName ?? ""}
                                </div>
                                {
                                    loggingOut ? <RagnaLoader text="Logging out" /> :
                                        (creds ?
                                            <div>
                                                <a href="#" onClick={_ => logout()}>Logout</a>
                                            </div> :
                                            <div>
                                                <a href="#" onClick={_ => setAuthModalOpen(true)}>Click here to login</a>
                                            </div>)
                                }
                            </div>
                        </div>
                    </div>
                    <div style={{
                        padding: 15, width: width > 992 ? "80vw" : "100vw",
                        overflow: "auto"
                    }} className={
                        navigation.state === "loading" ? "loading" : ""
                    }>
                        <AuthBox setCreds={setCreds} setModalOpen={setAuthModalOpen} modalOpen={authModalOpen} />
                        <div className="nav-thingy mb-3">
                            <Row>
                                <Col md={8} className="titles">
                                    <div>{navTitles.title}</div>
                                    <div>{navTitles.subtitle}</div>
                                </Col>
                                <Col>
                                    {
                                        navTitles.btns?.map((b, i) => {
                                            var modal =
                                                b.modal ? <RagnaModal
                                                    key={i}
                                                    customTrigger={<button>{b.name}</button>}
                                                    btnClass="btn btn-primary"
                                                    trigName={b.name}
                                                    title={b.modal.Title}
                                                    modalOpen={modalOpen}
                                                    setModalOpen={setModalOpen}
                                                    body={<b.modal.Component key={b.modal?.ModalProps?.url} setRootClass={props.setRootClass} modalOpen={modalOpen} setModal={setModalOpen} refreshTable={props.refreshTable} {...b.modal.ModalProps} />}
                                                /> : null;

                                            var current_access = cookies.get('creds').Access.split(",");

                                            return current_access.includes(b.access) ? (
                                                b.modal ? modal :
                                                    <NavLink key={i} className="btn btn-primary" to={b.link + (match.params.Id ?? "")}>
                                                        {b.name}
                                                    </NavLink>
                                            ) : <></>;
                                        })
                                    }
                                </Col>
                            </Row>
                            <hr className="my-1" />
                            <Breadcrumb />
                        </div>
                        {

                        }
                        <Outlet context={[creds, setCreds]} />
                    </div>
                </div>

            </div>
        </>
    );
}

export default Root;